import { Chip } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { RISK_SCORES } from '@app/configs/riskScore';
const CreditScore = ({ value, onChange }) => {
    const { t } = useTranslation();
    const toggleScore = (score) => {
        if (value.includes(score)) {
            onChange(value.filter((v) => v !== score));
        }
        else {
            onChange([...value, score]);
        }
    };
    return (<div>
            <h3 className="title-m text-neutral-primary-initial">{t('financing.investing_page_table.credit_score')}</h3>
            <div className="flex flex-wrap gap-2 mt-2">
                {RISK_SCORES.map((score) => (<Chip key={score} isSelected={value.includes(score)} onClick={() => toggleScore(score)}>
                        {score}
                    </Chip>))}
            </div>
        </div>);
};
export default CreditScore;
